/*

View returns a React component as the composition of a container and a functional component 
(pure function, stateless)

Views allow us to separate the functionality (in the containers) from the HTML representation,
 so that our code can be easily ported to other systems and we do not get our hands "dirty" in 
 the same file combining representation and functionality.

Some components will need state representation for things like scrolling down or accessing 
dom elements directly, but they should not manage anything related to app state.

*/
/*eslint no-console:0*/
import React from 'react';
import {debounce} from 'underscore';

const reactViewGenerator = ({containerFactory, Template, manager}) => {

    class T extends React.Component {
        constructor(props) {
            super(props);
            const viewParams = props.viewParams;

            this.container = containerFactory({manager, viewParams});
            this.onChangeRequest = debounce(this.onChangeRequest.bind(this), 10);
            if (this.container.on) {
                this.container.on('change', this.onChangeRequest);
            }
            this._mounted = false;
        }

        componentDidMount() {
            const container = this.container;


            if (container.init) {
                container.init();
            }
            this._mounted = true;
        }

        componentWillUnmount() {
            const container = this.container;

            if (this.container.off) {
                this.container.off('change', this.onChangeRequest);
            }
            if (container.close) {
                container.close();
            }
            this._mounted = false;
            this.container.onRequestUpdate = null;
        }

        onChangeRequest() {
            if (this._mounted) {
                //console.log('View: Container requested change');
                this.forceUpdate();
            }
        }


        render() {
            const container = this.container;

            return (
                <Template
                    container={container}
                />
            );

        }

    }
    return T;
};

export default reactViewGenerator;